import { useSettings } from "@/context/SettingsContext";
import { RulesContent } from "@/components/RulesContent";
import { HeartHandshake } from "lucide-react";

export default function Rules() {
  const { settings } = useSettings();
  const site = settings?.site_name || "Drops of Honey";

  return (
    <div className="max-w-3xl mx-auto px-4 lg:px-8 py-12">
      <div className="flex items-center gap-2 mb-2"><HeartHandshake className="w-6 h-6 brand-text" /><p className="font-tech text-xs uppercase tracking-widest brand-text">Community</p></div>
      <h1 className="font-display text-4xl font-bold mb-2">Community Rules</h1>
      <p className="text-muted-page mb-6 max-w-2xl">{site} is a friendly place for insulator collectors of every level. To keep it that way, everyone who uses the site agrees to a few simple rules.</p>

      <div className="surface border rounded-2xl p-6">
        <RulesContent />
      </div>

      <p className="text-center text-sm text-muted-page mt-6">By creating an account or posting on {site}, you agree to follow these rules.</p>
    </div>
  );
}
